import { 
  Disc3, // DJ (alternativo)
  Music, // Música en vivo genérica
  Music2, // Saxo
  Music4, // Violín
  Camera, // Fotomatón
  Video, // 360
  Sparkles, // Efectos especiales (CO2, fuego frío)
  Mic2, // Cantante / Atril
  Guitar, // Músicos
  Lightbulb, // Iluminación
  PartyPopper, // Otros
  Flame, // Fuego
  Wind, // CO2/humo
  Star, // Genérico
  Piano, // Piano
  Drum, // Percusión
  Monitor, // Pantalla
  Projector, // Proyector
  Mic, // Micrófono
  LayoutGrid, // Escenario
  ArrowUpRight, // Escalón
  Speaker, // Altavoces
  Volume2, // Sonido
  Headphones, // DJ / Auriculares
  Radio, // Equipo de sonido
  Tv, // TV/Pantalla alternativo
  Gem, // Ceremonia (anillo/diamante)
  UtensilsCrossed, // Momentos (banquete)
} from 'lucide-react';

// Mapeo de servicios a iconos y colores
const SERVICE_ICONS = {
  // DJ - Auriculares
  'dj': { icon: Headphones, color: 'text-cyan-400', bg: 'bg-cyan-500/20', label: 'DJ' },
  
  // Música en vivo - Saxofón
  'saxo': { icon: Music2, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Saxo' },
  'saxofón': { icon: Music2, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Saxo' },
  'saxofonista': { icon: Music2, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Saxo' },
  
  // Música en vivo - Violín
  'violín': { icon: Music4, color: 'text-purple-400', bg: 'bg-purple-500/20', label: 'Violín' },
  'violin': { icon: Music4, color: 'text-purple-400', bg: 'bg-purple-500/20', label: 'Violín' },
  'violinista': { icon: Music4, color: 'text-purple-400', bg: 'bg-purple-500/20', label: 'Violín' },
  
  // Música en vivo - Otros
  'cantante': { icon: Mic2, color: 'text-pink-400', bg: 'bg-pink-500/20', label: 'Cantante' },
  'percusionista': { icon: Drum, color: 'text-orange-400', bg: 'bg-orange-500/20', label: 'Percusión' },
  'percusión': { icon: Drum, color: 'text-orange-400', bg: 'bg-orange-500/20', label: 'Percusión' },
  'músico': { icon: Guitar, color: 'text-indigo-400', bg: 'bg-indigo-500/20', label: 'Músico' },
  'guitarra': { icon: Guitar, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Guitarra' },
  'guitarrista': { icon: Guitar, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Guitarra' },
  'piano': { icon: Piano, color: 'text-slate-300', bg: 'bg-slate-500/20', label: 'Piano' },
  'pianista': { icon: Piano, color: 'text-slate-300', bg: 'bg-slate-500/20', label: 'Piano' },
  'dúo': { icon: Music, color: 'text-violet-400', bg: 'bg-violet-500/20', label: 'Dúo' },
  
  // Fotomatón y 360
  'fotomatón': { icon: Camera, color: 'text-green-400', bg: 'bg-green-500/20', label: 'Fotomatón' },
  'fotomaton': { icon: Camera, color: 'text-green-400', bg: 'bg-green-500/20', label: 'Fotomatón' },
  'photocall': { icon: Camera, color: 'text-green-400', bg: 'bg-green-500/20', label: 'Photocall' },
  '360': { icon: Video, color: 'text-blue-400', bg: 'bg-blue-500/20', label: '360°' },
  'vídeo 360': { icon: Video, color: 'text-blue-400', bg: 'bg-blue-500/20', label: '360°' },
  'video 360': { icon: Video, color: 'text-blue-400', bg: 'bg-blue-500/20', label: '360°' },
  
  // Efectos especiales
  'co2': { icon: Wind, color: 'text-sky-400', bg: 'bg-sky-500/20', label: 'CO2' },
  'fuego': { icon: Flame, color: 'text-red-400', bg: 'bg-red-500/20', label: 'Fuego' },
  'fuego frío': { icon: Flame, color: 'text-blue-300', bg: 'bg-blue-400/20', label: 'Fuego Frío' },
  'sparkular': { icon: Sparkles, color: 'text-yellow-400', bg: 'bg-yellow-500/20', label: 'Sparkular' },
  'chispas': { icon: Sparkles, color: 'text-yellow-400', bg: 'bg-yellow-500/20', label: 'Chispas' },
  'bengalas': { icon: Sparkles, color: 'text-orange-300', bg: 'bg-orange-400/20', label: 'Bengalas' },
  'confeti': { icon: PartyPopper, color: 'text-pink-400', bg: 'bg-pink-500/20', label: 'Confeti' },
  'humo': { icon: Wind, color: 'text-slate-400', bg: 'bg-slate-500/20', label: 'Humo' },
  'niebla': { icon: Wind, color: 'text-slate-400', bg: 'bg-slate-500/20', label: 'Niebla' },
  
  // Iluminación
  'iluminación': { icon: Lightbulb, color: 'text-yellow-300', bg: 'bg-yellow-400/20', label: 'Luces' },
  'luces': { icon: Lightbulb, color: 'text-yellow-300', bg: 'bg-yellow-400/20', label: 'Luces' },
  
  // Equipamiento técnico / Corporativo
  'escenario': { icon: LayoutGrid, color: 'text-indigo-400', bg: 'bg-indigo-500/20', label: 'Escenario' },
  'tarima': { icon: LayoutGrid, color: 'text-indigo-400', bg: 'bg-indigo-500/20', label: 'Tarima' },
  'escalón': { icon: ArrowUpRight, color: 'text-slate-300', bg: 'bg-slate-500/20', label: 'Escalón' },
  'escalon': { icon: ArrowUpRight, color: 'text-slate-300', bg: 'bg-slate-500/20', label: 'Escalón' },
  'pantalla': { icon: Monitor, color: 'text-blue-400', bg: 'bg-blue-500/20', label: 'Pantalla' },
  'tv': { icon: Tv, color: 'text-blue-400', bg: 'bg-blue-500/20', label: 'TV' },
  'proyector': { icon: Projector, color: 'text-emerald-400', bg: 'bg-emerald-500/20', label: 'Proyector' },
  'cañón': { icon: Projector, color: 'text-emerald-400', bg: 'bg-emerald-500/20', label: 'Proyector' },
  'micro': { icon: Mic, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Micro' },
  'micrófono': { icon: Mic, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Micro' },
  'microfono': { icon: Mic, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Micro' },
  'atril': { icon: Mic2, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Atril' },
  'podio': { icon: Mic2, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Podio' },
  
  // Sonido
  'altavoces': { icon: Speaker, color: 'text-violet-400', bg: 'bg-violet-500/20', label: 'Altavoces' },
  'altavoz': { icon: Speaker, color: 'text-violet-400', bg: 'bg-violet-500/20', label: 'Altavoz' },
  'sonido': { icon: Volume2, color: 'text-violet-400', bg: 'bg-violet-500/20', label: 'Sonido' },
  'equipo': { icon: Radio, color: 'text-cyan-400', bg: 'bg-cyan-500/20', label: 'Equipo' },
  
  // Otros elementos
  'rampa': { icon: ArrowUpRight, color: 'text-slate-300', bg: 'bg-slate-500/20', label: 'Rampa' },
  'técnico': { icon: Radio, color: 'text-orange-400', bg: 'bg-orange-500/20', label: 'Técnico' },
  'tecnico': { icon: Radio, color: 'text-orange-400', bg: 'bg-orange-500/20', label: 'Técnico' },
  'hora': { icon: Star, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Hora Extra' },
  
  // Ceremonias (anillo/diamante) y Momentos (cubiertos para banquete)
  'ceremonia': { icon: Gem, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Ceremonia' },
  'momentos': { icon: UtensilsCrossed, color: 'text-amber-500', bg: 'bg-amber-500/20', label: 'Momentos' },
  
  // Por categoría (fallbacks)
  'categoria_dj': { icon: Headphones, color: 'text-cyan-400', bg: 'bg-cyan-500/20', label: 'DJ' },
  'categoria_fotomaton': { icon: Camera, color: 'text-green-400', bg: 'bg-green-500/20', label: 'Foto' },
  'categoria_360': { icon: Video, color: 'text-blue-400', bg: 'bg-blue-500/20', label: '360°' },
  'categoria_musica': { icon: Music, color: 'text-amber-400', bg: 'bg-amber-500/20', label: 'Música' },
  'categoria_efectos': { icon: Sparkles, color: 'text-purple-400', bg: 'bg-purple-500/20', label: 'Efectos' },
  'categoria_ceremonias': { icon: Gem, color: 'text-rose-400', bg: 'bg-rose-500/20', label: 'Ceremonia' },
};

// Función para encontrar el icono más apropiado para un servicio
const findServiceIcon = (servicio, categoria) => {
  const servicioLower = (servicio || '').toLowerCase();
  const categoriaLower = (categoria || '').toLowerCase();
  
  // PRIORIDAD 1: Ceremonias y Momentos (antes de DJ para evitar falsos positivos)
  if (servicioLower.includes('ceremonia')) {
    return SERVICE_ICONS['ceremonia'];
  }
  if (servicioLower.includes('momentos')) {
    return SERVICE_ICONS['momentos'];
  }
  
  // PRIORIDAD 2: Equipamiento técnico/corporativo (keywords específicos)
  if (servicioLower.includes('escenario') || servicioLower.includes('tarima') || servicioLower.includes('enmoquetado')) {
    return SERVICE_ICONS['escenario'];
  }
  if (servicioLower.includes('escalón') || servicioLower.includes('escalon')) {
    return SERVICE_ICONS['escalon'];
  }
  if (servicioLower.includes('pantalla') && !servicioLower.includes('360')) {
    return SERVICE_ICONS['pantalla'];
  }
  if (servicioLower.includes('proyector') || servicioLower.includes('cañón') || servicioLower.includes('canon')) {
    return SERVICE_ICONS['proyector'];
  }
  // ATRIL debe ir ANTES de micro (porque atril puede contener "micro" en descripción)
  if (servicioLower.includes('atril') || servicioLower.includes('podio')) {
    return SERVICE_ICONS['atril'];
  }
  if (servicioLower.includes('micro') && !servicioLower.includes('fotomaton')) {
    return SERVICE_ICONS['micro'];
  }
  if (servicioLower.includes('tv ') || servicioLower.startsWith('tv')) {
    return SERVICE_ICONS['tv'];
  }
  if (servicioLower.includes('altavoz') || servicioLower.includes('altavoces')) {
    return SERVICE_ICONS['altavoces'];
  }
  
  // PRIORIDAD 3: Efectos especiales
  if (servicioLower.includes('fuego')) {
    return servicioLower.includes('frío') ? SERVICE_ICONS['fuego frío'] : SERVICE_ICONS['fuego'];
  }
  if (servicioLower.includes('co2') || servicioLower.includes('co₂')) {
    return SERVICE_ICONS['co2'];
  }
  if (servicioLower.includes('humo') || servicioLower.includes('niebla')) {
    return SERVICE_ICONS['humo'];
  }
  
  // PRIORIDAD 4: Otros elementos
  if (servicioLower.includes('rampa')) {
    return SERVICE_ICONS['rampa'];
  }
  if (servicioLower.includes('técnico') || servicioLower.includes('tecnico')) {
    return SERVICE_ICONS['tecnico'];
  }
  
  // PRIORIDAD 5: Música en vivo
  if (servicioLower.includes('saxo')) {
    return SERVICE_ICONS['saxo'];
  }
  if (servicioLower.includes('violin') || servicioLower.includes('violín')) {
    return SERVICE_ICONS['violín'];
  }
  if (servicioLower.includes('cantante')) {
    return SERVICE_ICONS['cantante'];
  }
  if (servicioLower.includes('percusi')) {
    return SERVICE_ICONS['percusión'];
  }
  if (servicioLower.includes('guitarra') || servicioLower.includes('guitarrista')) {
    return SERVICE_ICONS['guitarra'];
  }
  if (servicioLower.includes('piano') || servicioLower.includes('pianista')) {
    return SERVICE_ICONS['piano'];
  }
  
  // PRIORIDAD 6: Fotomatón y 360
  if (servicioLower.includes('fotomaton') || servicioLower.includes('fotomatón') || servicioLower.includes('photocall')) {
    return SERVICE_ICONS['fotomaton'];
  }
  if (servicioLower.includes('360') || servicioLower.includes('plataforma 360')) {
    return SERVICE_ICONS['360'];
  }
  
  // PRIORIDAD 7: DJ (al final para evitar falsos positivos con "con DJ")
  if (servicioLower.includes('dj') && !servicioLower.includes('con dj') && !servicioLower.includes('sin dj')) {
    return SERVICE_ICONS['dj'];
  }
  if (servicioLower.includes('hora adicional')) {
    return SERVICE_ICONS['hora'];
  }
  
  // PRIORIDAD 2: Buscar por nombre de servicio en el mapeo general
  for (const [key, value] of Object.entries(SERVICE_ICONS)) {
    if (key.startsWith('categoria_')) continue; // Skip category entries
    if (servicioLower.includes(key) || key.includes(servicioLower.split(' ')[0])) {
      return value;
    }
  }
  
  // PRIORIDAD 3: Buscar por categoría
  if (categoriaLower.includes('dj')) return SERVICE_ICONS['categoria_dj'];
  if (categoriaLower.includes('fotomaton') || categoriaLower.includes('fotomatón')) return SERVICE_ICONS['categoria_fotomaton'];
  if (categoriaLower.includes('360')) return SERVICE_ICONS['categoria_360'];
  if (categoriaLower.includes('música') || categoriaLower.includes('musica') || categoriaLower.includes('vivo')) return SERVICE_ICONS['categoria_musica'];
  if (categoriaLower.includes('efecto') || categoriaLower.includes('especial')) return SERVICE_ICONS['categoria_efectos'];
  if (categoriaLower.includes('escenario')) return SERVICE_ICONS['escenario'];
  
  // Default
  return { icon: Star, color: 'text-slate-400', bg: 'bg-slate-500/20', label: servicio?.split(' ')[0] || '?' };
};

// Componente para mostrar iconos de servicios contratados
export const ServiciosIconsBar = ({ serviciosContratados = [], maxVisible = 5, size = 'sm' }) => {
  // Filtrar solo servicios contratados
  const serviciosActivos = serviciosContratados.filter(s => s.contratado);
  
  if (serviciosActivos.length === 0) return null;
  
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6'
  };
  
  const paddingClasses = {
    xs: 'p-1',
    sm: 'p-1.5',
    md: 'p-2'
  };
  
  const iconSize = sizeClasses[size] || sizeClasses.sm;
  const padding = paddingClasses[size] || paddingClasses.sm;
  
  // Agrupar servicios similares para no repetir iconos
  const serviciosUnicos = [];
  const categoriasVistas = new Set();
  
  for (const servicio of serviciosActivos) {
    const iconData = findServiceIcon(servicio.servicio, servicio.categoria);
    const key = iconData.label;
    
    if (!categoriasVistas.has(key)) {
      categoriasVistas.add(key);
      serviciosUnicos.push({ ...servicio, iconData });
    }
  }
  
  const visibles = serviciosUnicos.slice(0, maxVisible);
  const restantes = serviciosUnicos.length - maxVisible;
  
  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid="servicios-icons-bar">
      {visibles.map((servicio, index) => {
        const { iconData } = servicio;
        const IconComponent = iconData.icon;
        
        return (
          <div
            key={index}
            className={`${padding} rounded-md ${iconData.bg} flex items-center gap-1 group relative`}
            title={servicio.servicio}
          >
            <IconComponent className={`${iconSize} ${iconData.color}`} />
            {size !== 'xs' && (
              <span className={`text-xs ${iconData.color} font-medium hidden sm:inline`}>
                {iconData.label}
              </span>
            )}
            
            {/* Tooltip en hover */}
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-slate-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-50 border border-slate-700">
              {servicio.servicio}
              {servicio.cantidad > 1 && ` (x${servicio.cantidad})`}
            </div>
          </div>
        );
      })}
      
      {restantes > 0 && (
        <div className={`${padding} rounded-md bg-slate-600/30 text-slate-300 text-xs font-medium`}>
          +{restantes}
        </div>
      )}
    </div>
  );
};

// Componente compacto solo iconos (para calendario)
export const ServiciosIconsCompact = ({ serviciosContratados = [], maxVisible = 4 }) => {
  const serviciosActivos = serviciosContratados.filter(s => s.contratado);
  
  if (serviciosActivos.length === 0) return null;
  
  // Agrupar por categoría
  const categorias = new Map();
  
  for (const servicio of serviciosActivos) {
    const iconData = findServiceIcon(servicio.servicio, servicio.categoria);
    if (!categorias.has(iconData.label)) {
      categorias.set(iconData.label, { iconData, count: 1 });
    } else {
      categorias.get(iconData.label).count++;
    }
  }
  
  const items = Array.from(categorias.values()).slice(0, maxVisible);
  const restantes = categorias.size - maxVisible;
  
  return (
    <div className="flex items-center gap-0.5" data-testid="servicios-icons-compact">
      {items.map(({ iconData, count }, index) => {
        const IconComponent = iconData.icon;
        return (
          <div
            key={index}
            className={`p-1 rounded ${iconData.bg}`}
            title={`${iconData.label}${count > 1 ? ` (${count})` : ''}`}
          >
            <IconComponent className={`w-3.5 h-3.5 ${iconData.color}`} />
          </div>
        );
      })}
      {restantes > 0 && (
        <span className="text-xs text-slate-400 ml-0.5">+{restantes}</span>
      )}
    </div>
  );
};

export default ServiciosIconsBar;
// v2.1 - ServiciosIcons updated Sat Apr  4 15:34:51 UTC 2026
